import axios from 'axios';

export function addMailerGoogle(userId) {
    return axios({
        method: 'POST',
        url: '/api/v1/users/mailGates/fromTemplate/gmail',
        withCredentials: true,
        data: {
            userId,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getInternalMailers() {
    return axios({
        method: 'GET',
        url: '/api/v2/adminPanel/mailers',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function removeInternalMailer(id) {
    return axios({
        method: 'DELETE',
        url: `/api/v2/adminPanel/mailers/${id}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/analytics/mailers.js